<div class="retirement-page-container">
  <div class="retirement-banner-card">
    <!-- Attention Badge -->
    <div class="banner-badge">
      <span class="pulse-dot"></span>
      <span>Important Announcement</span>
    </div>

    <!-- Header Icon -->
    <div class="banner-icon-wrapper">
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
        <line x1="12" y1="9" x2="12" y2="13"></line>
        <line x1="12" y1="17" x2="12.01" y2="17"></line>
      </svg>
    </div>

    <!-- Title -->
    <h1 class="banner-title">This Portal is Retiring Soon</h1>

    <!-- Core Message in Polished English -->
    <p class="banner-description">
      Please be advised that this portal is scheduled to be retired permanently on
      <strong class="highlight-date">November 30, 2026</strong>.
      We kindly request you to transition to our newly upgraded portal for a faster, more secure, and feature-rich billing experience.
    </p>

    <!-- Migration Summary Box -->
    <div class="migration-box">
      <div class="migration-item">
        <span class="item-label">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
          Retirement Date
        </span>
        <span class="item-value date">November 30, 2026</span>
      </div>

      <div class="migration-item">
        <span class="item-label">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="2" y1="12" x2="22" y2="12"></line>
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
          </svg>
          Upgraded Portal
        </span>
        <a href="https://bill.pnixsoft.com" class="item-value url" target="_blank" rel="noopener noreferrer">
          bill.pnixsoft.com
        </a>
      </div>
    </div>

    <!-- Call to Action -->
    <div class="banner-action">
      <a href="https://bill.pnixsoft.com" class="cta-button" target="_blank" rel="noopener noreferrer">
        <span>Go to New Upgraded Portal</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"></line>
          <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </a>
    </div>

    <!-- Footer Note -->
    <p class="banner-footer-note">
      Please update your bookmarks to <a href="https://bill.pnixsoft.com" target="_blank" rel="noopener noreferrer">https://bill.pnixsoft.com</a> to ensure uninterrupted access.
    </p>
  </div>
</div>

<!-- Language Change Handler (hidden) -->
<span style="display:none;">
  <input type="button" class="on_language_changed" (click)="onLanguageChanged()" />
</span>